import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Classes from "./styles/style.module.css";
import Loading from "../../assets/containers/loadingDialog";
import CustomInput from "../../assets/components/customInput";
import CustomButton from "../../assets/components/CustomButton";
import UsersRequests from "../../assets/services/user";
import CustomCheckBox from "../../assets/components/CustomCheckBox";
import { useNavigate } from "react-router";
import appApi from "../../assets/utils/AppApi";
import errorHandler from "../../assets/utils/ErrorHandler";
import { FiRefreshCw } from "react-icons/fi";

const CheckUserExitsts = () => {
  const { loadingRegister } = useSelector(({ user }) => user);
  const [phoneNum, setPhoneNum] = useState("");
  const [nCode, setNCode] = useState("");
  // const [remember, setRemember] = useState(false);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [captcha, setCaptcha] = useState(null);
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const [captchaLoading, setCaptchaLoading] = useState(false);
  const refreshCaptcha = async () => {
    setCaptcha(null);
    setCaptchaAnswer("");
    setCaptchaLoading(true);
    try {
      const { data } = await appApi.get("/user/captcha");
      setCaptcha(data);
    } catch (error) {
      errorHandler(error);
    } finally {
      setCaptchaLoading(false);
    }
  };
  useEffect(() => { refreshCaptcha(); }, []);

  const checkUser = async (event) => {
    event.preventDefault();
    if (nCode && phoneNum && captcha && captchaAnswer && !loadingRegister && !captchaLoading) {
      const userData = {
        nationalCode: nCode,
        phone: phoneNum,
        captchaId: captcha.captchaId,
        captchaAnswer,
      };
      const success = await dispatch(UsersRequests.checkUserExists(userData));
      if (!success) await refreshCaptcha();
    }
  };

  return (
    <div className={Classes.loginContent}>
      <h2>خوش آمدید</h2>
      <h5 className="text-center">
        برای دسترسی به پیشخوان، شماره تلفن و کد ملی خود را وارد کنید.
      </h5>
      <form onSubmit={checkUser}>
        <CustomInput
          label={"شماره تماس"}
          value={phoneNum}
          placeholder={"شماره تلفن خود را وارد کنید"}
          handleChange={(value) => setPhoneNum(value)}
          name={"phoneNum"}
        />
        <CustomInput
          label={"کدملی"}
          placeholder={"کد ملی خود را وارد کنید"}
          value={nCode}
          handleChange={(value) => setNCode(value)}
          name="nationalCode"
        />
        <div className={Classes.captchaChallenge} aria-busy={captchaLoading}>
          <div className={Classes.captchaImage}>
            {captcha ? (
              <img src={captcha.image} alt="کد امنیتی" width="240" height="80" />
            ) : (
              <span role="status">
                {captchaLoading ? "در حال دریافت کد..." : "کد جدید دریافت کنید"}
              </span>
            )}
          </div>
          <CustomButton
            type="button"
            text={<FiRefreshCw aria-hidden="true" className={captchaLoading ? Classes.captchaSpinning : undefined} />}
            className={Classes.captchaRefresh}
            title="دریافت کد جدید"
            aria-label={captchaLoading ? "در حال دریافت کد..." : "دریافت کد جدید"}
            clickHandler={refreshCaptcha}
            disabled={captchaLoading || loadingRegister}
          />
        </div>
        <CustomInput
          label="کد امنیتی"
          placeholder="اعداد تصویر را وارد کنید"
          value={captchaAnswer}
          handleChange={setCaptchaAnswer}
          name="captchaAnswer"
        />
        <div className={Classes.checkBoxContainer}>
          <CustomCheckBox
            val={true}
            handleChange={() => {
              return;
            }}
            disabled={true}
            label={"مرابه خاطر بسپار"}
          />
        </div>
        {loadingRegister ? (
          <Loading className={"d-flex justify-content-center mt-4"} size={30} />
        ) : (
          <>
            <CustomButton
              text={"ورود"}
              color={"primary"}
              styles={{marginBottom:'16px'}}
            />
            <CustomButton
              text={"به شماره خود دسترسی ندارید ؟"}
              color={"primary"}
              clickHandler={(event) => {
                event.preventDefault();
                navigate('/createTicket');
              }}
              styles={{marginTop:'0px'}}
            />
          </>

        )}
      </form>
    </div>
  );
};

export default CheckUserExitsts;
